<template>
 <div class="col-12 py-1 px-0">
  <load v-if="loading" mode="table" />
  <div class="card card-body table table-sm bg-white border-4 border-bottom border-primary"
   v-for="historico in historicos" :key="historico.id" >
   <div v-if="historico.new_values">
   <div class="row py-2" style="border-bottom: 2px solid #007bff !important">
    <!-- <div class="col-12 py-1">
      <button class="btn btn-warning btn-sm" @click="restaurar">
           <i class="mdi mdi-undo mr-3"></i>Restaurar
         </button>
     </div> -->
     <div class="col-12 mb-3">
     <b>ABA:</b>
    {{ historico.auditable_type.replace('Modules\\Medidas\\Entities\\Medida','')
    .replace('AtoInfracional','Ato Infracional e Identificação Processual')
    .replace('Profissionalizacao','Profissionalização')
    .replace('Pespectiva','Perspectiva de Vida')
    .replace('sSocioeducativa','Medida Socioeducativa')
    .replace('Objetivo','Objetivos / Metas')
    .replace('Avaliacao','Avaliação Final')
     }}
    </div>
    <div class="col-6">
     <b>DATA DE REGISTRO:</b>
     {{ historico.created_at | moment("DD/MM/YYYY") }}<br />
     <b>EVENTO:</b> {{ historico.event }}
    </div>
    <div class="col-6">
     <b>RESPONSÁVEL PELA EDIÇÃO:</b> {{ historico.tecnico.nome }} -
     <small>{{ historico.tecnico.unidade.nome }} </small>
    </div>
   </div>
   <div class="row" v-html="makeHTML(historico.new_values.horario, 'HORÁRIO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.horario, 'HORÁRIO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.salario, 'SALÁRIO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.protocolo, 'PROTOCOLO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.cadastrado, 'CADASTRADO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.responsavel, 'TÉCNICO RESPONSÁVEL', 'name')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.unidade, 'UNIDADE DO RESPONSÁVEL', 'nome')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.outros_tecnicos, 'OUTRO(S) TÉCNICO(S)', null, true)"></div>
   <div class="row" v-html="makeHTML(historico.new_values.tipo, 'TIPO DE ATENDIMENTO')"></div>
   <div class="row" v-if="historico.new_values.tipo == 'ABORDAGEM SOCIAL'"
    v-html="makeHTML(historico.new_values.situacao_abordagem_social_nomes, 'SITUAÇÕES IDENTIFICADAS NA ABORDAGEM SOCIAL')">
   </div>
   <div class="row"
    v-html="makeHTML(historico.new_values.outra_situacao_abordagem_social, 'OUTRAS SITUAÇÕES IDENTIFICADAS')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.status_nome, 'STATUS')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.privado, 'SIGILO', null, false, true, ['1', 'Sim', 'Não'])"></div>

   <div class="row">
    <div class="col-12" v-if="historico.new_values.familia">
    <b>USUÁRIO(S) ATENDIDO(S):</b>
     <b class="mr-2 badge badge-default" v-for="(pessoa, index) in historico.new_values.pessoas" :key="pessoa.id">
      {{ pessoa.nome_completo }}
     </b>
     <small class="badge badge-danger my-2" v-if="
      historico.new_values.familia.rf_situacao_rua != null &&
      historico.new_values.familia.rf_situacao_rua.status == 1
     ">RF registrado em Situação de Rua no Sistema</small>
    </div>
   </div>

   <div class="row" v-html="makeHTML(verificarValueArray(historico.new_values.tipo_servico_id, servicos), 'SERVIÇO')">
   </div>
   <div class="row"
    v-html="makeHTML(historico.new_values.local, 'LOCAL')">
   </div> 
    <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.assessoramento_juridico , $root.arrays.assessoramento_juridico), 
      'ASSESSORAMENTO JURÍDICO')">
   </div>    
   <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.reincidencia , $root.arrays.reincidencia), 
      'REINCIDÊNCIA')">
   </div>  
   <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.ato_inflacional , $root.arrays.ato_inflacional), 
      'ATO INFRACIONAL')">
   </div>     
   <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.registro_carteira , $root.arrays.pergunta), 
      'REGISTRO EM CARTEIRA')">
   </div>      
   <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.experiencia_anterior , $root.arrays.pergunta), 
      'EXPERIÊNCIAS ANTERIORES')">
   </div>   
   <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.participou_cursos , $root.arrays.pergunta), 
      'JÁ PARTICIPOU DE CURSOS PROFISSIONALIZANTES')">
   </div>  
   <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.metas_pia , $root.arrays.metas_pia), 
      'AS METAS E OBJETIVOS ESTABELECIDAS NO PIA FORAM ALCANÇADOS')">
   </div>    
   <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.cumpriu_condicionalidade , $root.arrays.cumpriu_condicionalidade), 
      'O ADOLESCENTE CUMPRIU COM AS CONDICIONALIDADES ESTABELECIDAS NO TERMO DE COMPROMISSO')">
   </div>     
   <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.disponibilidade_adolescente , $root.arrays.medidas_avaliacao), 
      'SOBRE A DISPONIBILIDADE DO ADOLESCENTE PARA REALIZAR AS ATIVIDADES PROPOSTAS')">
   </div>    
   <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.pontualidade , $root.arrays.medidas_avaliacao), 
      'PONTUALIDADE')">
   </div>    
   <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.sociabilidade , $root.arrays.medidas_avaliacao), 
      'SOCIABILIDADE COM A EQUIPE E NO LOCAL DE PRESTAÇÃO DA MEDIDA')">
   </div>     
   <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.participacao_cumprimento , $root.arrays.medidas_avaliacao), 
      'A PARTICIPAÇÃO DA FAMÍLIA NO PROCESSO DE CUMPRIMENTO DA MEDIDA PELO ADOLESCENTE')">
   </div>  
   <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.participacao_cumprimento , $root.arrays.medidas_avaliacao), 
      'A PARTICIPAÇÃO DA FAMÍLIA NO PROCESSO DE CUMPRIMENTO DA MEDIDA PELO ADOLESCENTE')">
   </div>     
   <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.participacao_planejamento , $root.arrays.medidas_avaliacao), 
      'PARTICIPAÇÃO NO PLANEJAMENTO DO SEU CRONOGRAMA DE ATIVIDADES')">
   </div> 
   <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.documentos_recebidos , $root.arrays.documentos_recebidos), 
      'DOCUMENTOS RECEBIDOS REFERENTE A MSE EM EXECUÇÃO E EXECUÇÕES ANTERIORES')">
   </div> 
     <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.trabalhando , $root.arrays.pergunta), 
      'ESTÁ TRABALHANDO?')">
   </div>
     <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.gostaria_participar , $root.arrays.pergunta), 
      'GOSTARIA DE PARTICIPAR DE CURSOS PROFISSIONALIZANTES')">
   </div>
     <div class="row"
    v-html="makeHTML(verificarValueArray(
      historico.new_values.deseja_alguma_profissao , $root.arrays.pergunta), 
      'DESEJA SEGUIR ALGUMA PROFISSÃO?')">
   </div>
   <div class="row" v-html="makeHTML(historico.new_values.quais_cursos_gostaria_participar , 'QUAIS CURSOS GOSTARIA DE PARTICIPAR')"></div> 
   <div class="row" v-html="makeHTML(historico.new_values.qual_curso , 'QUAIS CURSOS PROFISSIONALIZANTES')"></div> 
   <div class="row" v-html="makeHTML(historico.new_values.planos_futuro , 'PLANOS FUTUROS')"></div> 
   <div class="row" v-html="makeHTML(historico.new_values.recebe_influencia_negativa , 'O ADOLESCENTE RECEBE ALGUM TIPO DE INFLUÊNCIA NEGATIVA EM RELAÇÃO AOS INTERESSES E PLANOS PARA O FUTURO')"></div> 
   <div class="row" v-html="makeHTML(historico.new_values.recebe_apoio , 'O ADOLESCENTE RECEBE ALGUM TIPO DE  APOIO OU ACOLHIMENTO EM RELAÇÃO AOS INTERESSES E PLANOS PARA O FUTURO')"></div> 
   <div class="row" v-html="makeHTML(historico.new_values.familia_corresponde , 'A FAMILIA CORRESPONDE A ESTE INTERESSE')"></div> 
   <div class="row" v-html="makeHTML(historico.new_values.familia_corresponde , 'A FAMILIA CORRESPONDE A ESTE INTERESSE')"></div> 
   <div class="row" v-html="makeHTML(historico.new_values.observacoes , 'OBSERVAÇÃO')"></div> 
   <div class="row" v-html="makeHTML(historico.new_values.outros_documentos, 'OUTROS DOCUMENTOS')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.numero, 'NÚMERO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.autos, 'AUTOS Nº')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.outra_unidade_id, 'OUTRA UNIDADE')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.outra_unidade, 'OUTRA UNIDADE')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.data_prevista_formatado, 'DATA DO AGENDAMENTO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.hora_prevista_formatado, 'HORA DO AGENDAMENTO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.descricao_sumaria, 'OBSERVAÇÃO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.processo_data_final, 'DATA FINAL PROCESSO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.processo_data_inicial, 'DATA INICIAL PROCESSO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.acomp_data_final, 'DATA FINAL ACOMPANHAMENTO ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.acomp_data_inicial, 'DATA INICIAL ACOMPANHAMENTO ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.documental_prazo, 'SITUAÇÃO DOCUMENTAL PRAZO ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.arte_prazo, 'ARTE, CULTURA, ESPORTE E LAZER PRAZO ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.aspecto_prazo, 'ASPECTOS SOCIOFAMILIARES PRAZO ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.processual_prazo, 'PROCESSUAL PRAZO ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.saude_prazo, 'SAÚDE PRAZO ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.educacao_prazo, 'EDUCAÇÃO PRAZO ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.profissionalizacao_prazo, 'PROFISSIONALIZAÇÃO PRAZO ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.aspecto_prazo, 'ASPECTOS SOCIOFAMILIARES PRAZO ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.condicao_prazo, 'CONDIÇÕES SOCIOECONÔMICAS PRAZO ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.vulnerabildiade_prazo, 'VULNERABILIDADE SOCIOFAMILIARES PRAZO ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.desligamento_prazo, 'PREPARAÇÃO PARA DESLIGAMENTO PRAZO ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.data_avaliacao, 'DATA AVALIAÇÃO ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.orientador_social_responsavel_nome, 'ORIENTADOR SOCIAL RESPONSÁVEl ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.acomp_creas_unidade_nome, 'LOCAL CUMPRIMENTO DA MEDIDA ')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.acomp_creas_unidade_nome, 'LOCAL CUMPRIMENTO DA MEDIDA ')"></div>


   <div class="row">
    <div class="col-12 py-1" v-if="historico.new_values.vulnerabilidades">
     <b>VULNERABILIDADE(S):</b>
     <b class="mr-2 badge badge-default" v-for="(vulnerabilidade, index) in historico.new_values
      .vulnerabilidades" :key="vulnerabilidade.id">
      {{ verificarValueArray(vulnerabilidade, vulnerabilidades_tipos) }}
     </b>
    </div>
    <div class="col-12 py-1" v-if="
     historico.new_values.denuncias &&
     historico.new_values.denuncias.length > 0
    ">
     <b>DENÚNCIAS:</b>
     <b class="mr-2 badge badge-default" v-for="(denuncia, index) in historico.new_values
      .denuncias" :key="index">
      <router-link v-if="denuncia" class="btn btn-sm btn-light py-0 px-1 my-1"
       :to="`/dashboard/denuncias/edit/${denuncia.id}`">
       {{ denuncia.protocolo }}
      </router-link>
     </b>
    </div>
   </div>
  </div>
 </div>
 
  <h2 v-if="historicos.length <= 0" class="text-warning">
   <span class="mdi mdi-clipboard-search-outline"></span> Por enquanto
   não temos nenhuma atualização.
  </h2>
 </div>
</template>
<script>
export default {
 props: ["id", "vulnerabilidades"],
 data() {
  return {
   loading: true,
   historicos: {},
   servicos: [],
   unidades: [],
   vulnerabilidades_tipos: [],
  };
 },
 watch: {
  vulnerabilidades() {
   this.vulnerabilidades_tipos = this.vulnerabilidades;
  },
 },
 mounted() {
  this.vulnerabilidades_tipos = this.vulnerabilidades;
  this.getHistorico();
  // this.getServicos();
  // this.getUnidades();
 },
 methods: {
  getHistorico() {
   this.loading = true;
   axios
    .get("api/dashboard/medida/historico/audit/" + this.id)
    .then((response) => {
     this.historicos = response.data.historicos;
     this.servicos = response.data.servicos;
    })
    .finally(() => {
     this.loading = false;
    })
    .catch(() => {
     swal.fire({
      title: "Ops!",
      html: `Os dados de auditoria não foram carregado corretamente<br>${error}`,
      icon: "error",
     });
    });
  },
  restaurar() {
   console.log("teste");
  },
  // getServicos() {
  //  axios.get(`api/dashboard/atendimento/servicos`).then((response) => {
  //   this.servicos = response.data;
  //  });
  // },
  // getUnidades() {
  //  axios
  //   .get(`api/dashboard/unidades/get/externas/PLANTAO`)
  //   .then((response) => {
  //    this.unidades = response.data;
  //   });
  // },
  makeHTML(value, label, index = null, loop = false, select = false, options = null) {
   if (value != null && value != '') {
    if (loop) {
     let itens = "";
     value.forEach(item => {
      itens += `<b class="mr-2 badge badge-default">${item}</b>`;
     });
     return `<div class="col-12 py-1"><b>${label}:</b> ${itens}</div>`;
    } else if (select) {
     return `<div class="col-12 py-1"><b>${label}:</b> ${value == options[0] ? options[1] : options[2]}</div>`;
    } else {
     value = typeof value === "object" ? value[index] : value;
     return `<div class="col-12 py-1"><b>${label}:</b> ${value}</div>`;
    }
   }
  },
  verificarValueArray(value, array) {
   if (value != null && value != '') {
    const result = array.find((item) => item.id == value);
    return result ? result.value : "";
   }
  },
 },
};
</script>
